module.exports = __webpack_public_path__ + "static/media/vi.c870dd8b.png";